export default __webpack_public_path__ + "static/media/LogoTSR.ec2113e4.svg";